// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"pureflo_contentContainer__1RXe5","content":"pureflo_content__1O_Ei"};